import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { isAuthenticated, logout } = useAuth();
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <>
      <div className="bg-white py-2 flex flex-wrap items-center justify-center text-xs px-2 overflow-hidden">
        <img src="/usFlag.png" alt="American Flag" className="h-5 mr-2" />
        <span className="text-center">An official registry of the <a href="https://www.justice.gov/crt/disability-rights-section" className="hover:underline"> Department of Justice: Civil Rights Division</a></span>
      </div>
      <header className="bg-primary-600 text-white shadow-md relative z-40">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center py-4">
            <Link to="/" className="flex items-center space-x-2 flex-shrink-0">
              <img
                src="/USSdogsLogo.png"
                alt="US Service Dogs Logo"
                className="h-8 sm:h-10 w-auto"
              />
              <div className="overflow-hidden">
                <h1 className="text-lg sm:text-xl font-bold truncate">US Service Dog Registry</h1>
                <p className="text-xs text-primary-100 truncate">Official National Registry</p>
              </div>
            </Link>

            {/* Mobile menu button */}
            <button
              className="md:hidden text-white"
              onClick={toggleMobileMenu}
              aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>


            {/* Desktop navigation */}
            <nav className="hidden md:flex items-center space-x-8">
              <Link
                to="/"
                className={`text-sm font-medium hover:text-primary-100 transition-colors ${isActive('/') ? 'text-white border-b-2 border-accent-600 pb-1' : 'text-primary-100'}`}
              >
                Home
              </Link>
              <Link
                to="/register"
                className={`text-sm font-medium hover:text-primary-100 transition-colors ${isActive('/register') ? 'text-white border-b-2 border-accent-600 pb-1' : 'text-primary-100'}`}
              >
                Register a Service Dog
              </Link>
              <Link
                to="/lookup"
                className={`text-sm font-medium hover:text-primary-100 transition-colors ${isActive('/lookup') ? 'text-white border-b-2 border-accent-600 pb-1' : 'text-primary-100'}`}
              >
                Verify a Registration
              </Link>
              {isAuthenticated ? (
                <>
                  <Link
                    to="/admin/dashboard"
                    className={`text-sm font-medium hover:text-primary-100 transition-colors ${isActive('/admin/dashboard') ? 'text-white border-b-2 border-accent-600 pb-1' : 'text-primary-100'}`}
                  >
                    Admin Dashboard
                  </Link>
                  <button
                    onClick={logout}
                    className="text-sm font-medium bg-accent-600 hover:bg-accent-700 px-4 py-2 rounded transition-colors"
                  >
                    Logout
                  </button>
                </>
              ) : (
                <Link
                  to="/admin/login"
                  className="text-sm font-medium bg-transparent hover:bg-primary-700 border border-primary-100 px-4 py-2 rounded transition-colors"
                >
                  Admin Login
                </Link>
              )}
            </nav>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <>
            <div className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden" onClick={toggleMobileMenu}></div>
            <nav className="md:hidden fixed w-full animate-fade-in z-50 shadow-lg border-t-2 border-accent-600" style={{ backgroundColor: '#0A2463', top: '80px', left: 0, right: 0 }}>
            <div className="container mx-auto px-4 py-6 flex flex-col space-y-4">
              <Link
                to="/"
                className={`text-sm font-medium hover:text-white transition-colors py-2 block ${isActive('/') ? 'text-white border-l-4 border-accent-600 pl-2' : 'text-white pl-3'}`}
                onClick={toggleMobileMenu}
              >
                Home
              </Link>
              <Link
                to="/register"
                className={`text-sm font-medium hover:text-white transition-colors py-2 block ${isActive('/register') ? 'text-white border-l-4 border-accent-600 pl-2' : 'text-white pl-3'}`}
                onClick={toggleMobileMenu}
              >
                Register a Service Dog
              </Link>
              <Link
                to="/lookup"
                className={`text-sm font-medium hover:text-white transition-colors py-2 block ${isActive('/lookup') ? 'text-white border-l-4 border-accent-600 pl-2' : 'text-white pl-3'}`}
                onClick={toggleMobileMenu}
              >
                Verify a Registration
              </Link>
              {isAuthenticated ? (
                <>
                  <Link
                    to="/admin/dashboard"
                    className={`text-sm font-medium hover:text-white transition-colors py-2 block ${isActive('/admin/dashboard') ? 'text-white border-l-4 border-accent-600 pl-2' : 'text-white pl-3'}`}
                    onClick={toggleMobileMenu}
                  >
                    Admin Dashboard
                  </Link>
                  <button
                    onClick={() => {
                      logout();
                      toggleMobileMenu();
                    }}
                    className="text-sm font-medium bg-accent-600 hover:bg-accent-700 px-4 py-2 rounded transition-colors text-white text-left ml-3 mt-2 block"
                  >
                    Logout
                  </button>
                </>
              ) : (
                <Link
                  to="/admin/login"
                  className="text-sm font-medium bg-white text-primary-600 hover:bg-neutral-100 px-4 py-3 rounded transition-colors block mt-4 text-center font-bold"
                  onClick={toggleMobileMenu}
                >
                  Admin Login
                </Link>
              )}
            </div>
          </nav>
          </>
        )}
      </header>
    </>
  );
};

export default Header;
